<template>
    <v-tooltip bottom max-width="300" color="grey darken-4">
        <template #activator="{ on }">
            <div v-on="on" class="header-item-container">
                <div class="header-item-title" :class="{ 'header-item-title-tooltip': toolTip }">
                    {{ title }}
                </div>
                <div v-if="toolTip" class="header-item-icon">
                    <v-icon small color="black">
                        mdi-help-circle-outline
                    </v-icon>
                </div>
            </div>
        </template>
        <typo name="body-14-light">
            {{ toolTip }}
        </typo>
    </v-tooltip>
</template>

<script>
export default {
    components: {},
    props: ["title", "toolTip"],
};
</script>

<style scoped lang="sass">
.header-item-container
    display: flex
    align-items: center
    justify-content: center

.header-item-title-tooltip
    padding-left: 24px

.header-item-icon
    margin-left: 8px
</style>
